/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "UpdateItemTaxesRequest": {
                        "fields": {
                          "itemIds": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "taxesToEnable": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "taxesToDisable": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "UpdateItemTaxesResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateItemTaxesRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateItemTaxesResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateItemTaxesRequest @ squareup/connect/v2/catalog/interfaces/update-item-taxes.proto at 18:1
 */
export const UpdateItemTaxesRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateItemTaxesRequest');
fixType(UpdateItemTaxesRequest, {
  itemIds: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateItemTaxesRequest);
/**
 * SOURCE UpdateItemTaxesResponse @ squareup/connect/v2/catalog/interfaces/update-item-taxes.proto at 36:1
 */
export const UpdateItemTaxesResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateItemTaxesResponse');
fixType(UpdateItemTaxesResponse);
Builder.createAndAttachToType(UpdateItemTaxesResponse);